/**
 * Shelf Selector functionality
 * Handles adding product variants to cart from shelf selector buttons
 */

function handleButtonClick(variant_id, finalSale, productId) {
  const attributes = {};

  if (finalSale) {
    attributes['_finalsale'] = 'true';
    // The message will be set by the Liquid template that calls this function
    attributes['Final Sale'] = window.FarmRio?.settings?.checkout_item_final_sale_message || 'Final Sale - No Returns or Exchanges';
  }

  const watched_product_video = sessionStorage.getItem('watched_product_video');
  if (watched_product_video) {
    const productsIds = JSON.parse(watched_product_video);
    const userWatchedVideo = productsIds.find((id) => String(id) === String(productId));
    if (userWatchedVideo) {
      attributes['_watched_product_video'] = 'true';
    }
  }
  
  // Use Cart service to add to cart
  if (window.Cart && typeof window.Cart.addProductVariantToCart === 'function') {
    window.Cart.addProductVariantToCart(variant_id, 1, attributes);
  } else {
    console.error('Cart service not available');
  }
}

// Make it globally available
window.handleButtonClick = handleButtonClick;
